import * as React from 'react';

const HeadNegativeGraphicSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 144 144" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                d="M53.35 120v-18c0-15-11.937-27.603-11.937-45S58.425 24 75.73 24s34.318 15.603 34.318 33L119 79.5h-8.952V93c0 4.97-4.01 9-8.953 9H89.16v18"
                fill="#DBDAE3"
                fillRule="nonzero"
            />
            <path
                d="M75.73 51a25.477 25.477 0 01-6.026 16.5l14.979 9H50.365C36.356 76.5 25 65.084 25 51s11.356-25.5 25.365-25.5c14.01 0 25.365 11.416 25.365 25.5"
                fill="#FFF"
                fillRule="nonzero"
            />
            <path
                d="M75.73 51a25.477 25.477 0 01-6.026 16.5l14.979 9H50.365C36.356 76.5 25 65.084 25 51s11.356-25.5 25.365-25.5c14.01 0 25.365 11.416 25.365 25.5z"
                stroke="#1E0A3C"
                strokeWidth={3}
            />
            <path
                d="M68.27 51c0 9.942-8.016 18-17.905 18-9.89 0-17.905-8.058-17.905-18s8.016-18 17.905-18c9.89 0 17.905 8.058 17.905 18"
                fill="#F05537"
                fillRule="nonzero"
            />
            <path
                d="M57.825 43.5l-14.92 15M57.825 58.5l-14.92-15"
                stroke="#FFF"
                strokeWidth={3}
            />
        </g>
    </svg>
);

HeadNegativeGraphicSvg.displayName = 'HeadNegativeGraphicSvg';
export default HeadNegativeGraphicSvg;
